import type { Shop } from './shops.interface'
import { StorageSerializers } from '@vueuse/core'

export const useShops = createGlobalState(
  () => {
    const shops = useStorage<Shop[]>('shops', [], undefined, { serializer: StorageSerializers.object })
    const loading = ref(false)
    const { onError } = useServerErrorHandler()

    const fetchShops = async () => {
      if (loading.value)
        return
      loading.value = true
      try {
        const response = await getAll<Shop>({ url: '/api/shops' })
        shops.value = response
      }
      catch (error) {
        onError(error)
      }
      finally {
        loading.value = false
      }
    }

    const reset = () => {
      shops.value = []
      loading.value = false
    }

    return { shops, loading, fetchShops, reset }
  },
)
